import React from 'react'

const Thumbnail = ({ src, alt, className, width, style, ...props }) =>
  <div
    {...props}
    className={`thumbnail rounded-circle ${className || ''}`}
    style={{ backgroundImage: `url("${src}")`, width: `${width}px`, ...style }}
  >
    {alt ? <span className="sr-only">alt</span> : null}
  </div>

export default Thumbnail
